import { h } from "./../../utils/createElement";
import { __extends } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { FormItemContext } from './context';
import { consumeTheme } from '../../utils/theme';
import { createGlobalInstanceId } from '../../utils/instanceId';
function getTextOfStatus(message, status) {
    if (React.isValidElement(message) || typeof message === 'string') {
        return status === 'error' ? message : undefined;
    }
    if (typeof message === 'object') {
        return message[status];
    }
}
var Item = (function (_super) {
    __extends(Item, _super);
    function Item() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = createGlobalInstanceId('FormItem');
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, message = _a.message, label = _a.label, labelStyle = _a.labelStyle;
            var _b = _this.props, required = _b.required, status = _b.status;
            var cls = classNames(prefixCls, className);
            var text = getTextOfStatus(message, status);
            var textCls = classNames(prefixCls + "-text", prefixCls + "-text-" + status);
            var children = Array.isArray(_this.props.children) ? _this.props.children[0] : _this.props.children;
            if (React.isValidElement(children)) {
                var props = children.props;
                if (props['data-create-form-payload']) {
                    try {
                        var _c = props['data-create-form-payload'], id = _c.id, form = _c.form, option = _c.option;
                        var getFieldError = form.getFieldError, isFieldTouched = form.isFieldTouched;
                        if (Array.isArray(option.rules) &&
                            option.rules.filter(function (rule) { return rule.required; }).length) {
                            required = true;
                        }
                        var accountError = isFieldTouched(id) && getFieldError(id);
                        if (accountError) {
                            status = 'error';
                            text = accountError[id].errors[0].message;
                            textCls = classNames(prefixCls + "-text", prefixCls + "-text-" + status);
                        }
                    }
                    catch (e) {
                        console.error('Item 组件内部错误', e);
                    }
                }
            }
            var hasError = status === 'error';
            return (h(FormItemContext.Provider, { value: { status: status } },
                h("div", { className: cls, style: style, "aria-required": required, "aria-invalid": hasError, "aria-describedby": _this.id },
                    label ?
                        h("div", { className: classNames(prefixCls + "-label"), style: labelStyle },
                            required ? h("span", { className: classNames(prefixCls + "-label-required") }, "*") : null,
                            label)
                        : null,
                    h("div", { className: classNames(prefixCls + "-content") },
                        children,
                        text ? h("div", { className: textCls, id: _this.id }, text) : null))));
        };
        return _this;
    }
    Item.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Item;
}(React.Component));
export default Item;
Item.defaultProps = {
    prefixCls: 'dui-form-item',
    status: 'default',
    required: false
};
Item.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    status: PropTypes.oneOf(['default', 'success', 'error', 'warning']),
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.element]),
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    labelStyle: PropTypes.object,
    required: PropTypes.bool
};
